import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// EditProfiles Redux States
import { GET_EDITPROFILE, EDIT_EDITPROFILE } from "./actionTypes";
import { apiError, setEditProfile, editEditProfileSuccess } from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getEditProfile({ payload: { idEditProfile, isForm } }) {
  try {
    const response = yield call(axios.get, `/user/profile`);
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setEditProfile(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editEditProfile({
  payload: { idEditProfile, newEditProfileValues },
}) {
  try {
    const response = yield call(
      axios.patch,
      `/user/profile`,
      newEditProfileValues
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      let url_avatar = response.data.url_avatar;
      yield put(editEditProfileSuccess(message, url_avatar));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

export function* watchGetEditProfile() {
  yield takeEvery(GET_EDITPROFILE, getEditProfile);
}
export function* watchEditEditProfile() {
  yield takeEvery(EDIT_EDITPROFILE, editEditProfile);
}
function* authSaga() {
  yield all([fork(watchGetEditProfile), fork(watchEditEditProfile)]);
}

export default authSaga;
